export const extractErrorMessage = (error, fallback) => {
  const fieldErrors = error?.data?.errors;
  const firstValue = fieldErrors && Object.values(fieldErrors)[0];
  if (Array.isArray(firstValue)) {
    return firstValue.flat()[0];
  }
  return error?.data?.message || fallback;
};
